import { useAppQuery } from "~/hooks/useAppQuery"
import { getChats } from "../server/chats.functions"

export const chatsQueryKey = (query: string) => ["home", "chats", query] as const

export function useChats(query = "") {
  const normalizedQuery = query.trim()

  return useAppQuery({
    queryKey: chatsQueryKey(normalizedQuery),
    queryFn: () => getChats({ data: { query: normalizedQuery || undefined } }),
    errorMessage: "Не удалось загрузить чаты",
  })
}
